// More like X on the home page (Oct 2026): a shelf for each of the tunes you
// opened last, of the tunes nearest it in its changes, by its composer, or
// sharing a distinctive feel (src/music/recommend.ts). One row each that
// scrolls sideways, so three shelves cost three rows of the page.

import { libraryTasteTune, useHomeRecommendations } from '@/data/homeRecommendations';
import type { MoreLikeReason } from '@/music/recommend';
import { HomeTile } from './HomeTile';
import { tuneHref } from './tuneHref';

function reasonText(reason: MoreLikeReason): string {
  switch (reason.kind) {
    case 'same-changes':
      return 'Same changes';
    case 'similar-changes':
      return 'Similar changes';
    case 'feel':
      return reason.feel;
  }
}

export function MoreLikeShelves() {
  const home = useHomeRecommendations();
  if (!home) return null;
  const { stats, shelves } = home;
  if (shelves.length === 0) return null;

  return (
    <>
      {shelves.map(({ anchor, items }) => {
        const heading = `home-more-like-${anchor}`;
        return (
          <section
            key={anchor}
            className="home-shelf"
            aria-labelledby={heading}
            data-testid="home-more-like"
            data-scroll-anchor={`more-like-${stats.tunes[anchor].t}`}
          >
            <h2 id={heading}>More like {stats.tunes[anchor].t}</h2>
            <ul className="home-shelf-row">
              {items.map(({ tune: index, reason }) => {
                const tune = stats.tunes[index];
                return (
                  <li key={index}>
                    <HomeTile
                      kind="shelf"
                      testId="home-more-like-tune"
                      reason={reason && reasonText(reason)}
                      title={tune.t}
                      melody={!!tune.m}
                      foot={tune.c}
                      to={tuneHref(tune.t, tune.c, tune.rb ? 'realbook' : undefined)}
                      taste={libraryTasteTune(tune)}
                    />
                  </li>
                );
              })}
            </ul>
          </section>
        );
      })}
    </>
  );
}
